"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmValidationSchema = void 0;
const yup_1 = require("yup");
exports.confirmValidationSchema = (0, yup_1.string)()
    .equals([(0, yup_1.ref)("password")], "form.validations.patternMismatch")
    .required("form.validations.valueMissing");
//# sourceMappingURL=confirm.js.map